import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeLayout from "../views/home/HomeLayout";
import Home from '../views/home/Home.vue'
import Signup from "../views/home/Signup";
import Signin from "../views/home/Signin";
import EventLayout from "../views/event/EventLayout";
import DataList from "../views/admin/DataList";
import AdminLayout from "../views/admin/AdminLayout";
import EventTool from "../views/event/EventTool";
import EventToolExample from "../views/EventToolExample";
import ResetPass from "../views/home/ResetPass";
import DataListOpen from "../views/home/DataListOpen";
import EventToolOpen from "../views/EventToolOpen";

Vue.use(VueRouter)

const routes = [
    {
        path: "/",
        name: 'Home',
        component: Home,
        meta: {
            title: '事件风暴,EventStorming',
        },
    },
    {
        path: '/event-tool-example', //X6demo
        name: 'EventToolExample',
        component: EventToolExample,
        meta: {
            title: '事件风暴体验',
        },
    },
    {
        path: '/event-tool-open/:id/:name',
        name: 'EventToolOpen',
        component: EventToolOpen,
        meta: {
            title: '公共风暴',
        },
    },
    //首页
    {
        name: 'layout',
        path: '/',
        component: HomeLayout,
        redirect: '/',
        children: [
            {
                path: '/signup', //注册
                name: 'Signup',
                component: Signup,
                meta: {
                    title: '注册',
                },
            },
            {
                path: '/signin', //登录
                name: 'Signin',
                component: Signin,
                meta: {
                    title: '登录',
                },
            },
            {
                path: '/reset-pass', //重置密码
                name: 'ResetPass',
                component: ResetPass,
                meta: {
                    title: '重置密码',
                },
            },
            {
                path: '/data-list-open',
                name: 'DataListOpen',
                component: DataListOpen,
                meta: {
                    title: '公共风暴',
                },
            },
        ],
    },
    {
        path: '/eventTool',
        name: 'Event',
        component: EventLayout,
        children: [
            {
                path: '/eventTool/:id/:name',
                name: 'EventTool',
                component: EventTool,
                meta: {
                    title: '事件风暴',
                },
            },
        ],
    },
    {
        path: '/admin',
        name: 'AdminLayout',
        component: AdminLayout,
        children: [
            {
                path: '/dataList',
                name: 'DataList',
                component: DataList,
                meta: {
                    title: '事件风暴',
                },
            },
        ],
    },
]

const RouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
    return RouterPush.call(this, to).catch(err => err)
}
const RouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(to) {
    return RouterReplace.call(this, to).catch(err => err)
}

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
